function popupAgeVerification() {
    const popup = document.getElementById("popupAgeVerification");
    const body = document.body;

    if (!popup) return;

    const btnNo = popup.querySelector("#btnAgeVerificationNo");
    const btnYes = popup.querySelector("#btnAgeVerificationYes");
    const elNotVerification = popup.querySelector("#notVerification");
    const elPopContent = popup.querySelector("#popupAgeVerificationContent");

    if (localStorage.getItem("ageVerified") !== "true") {
        popup.classList.remove("hidden");
        body.classList.add("no-scroll");
    }

    if (btnYes) {
        btnYes.addEventListener("click", function () {
            localStorage.setItem("ageVerified", "true");
            popup.classList.add("hidden");
            body.classList.remove("no-scroll");
        });
    }

    if (btnNo) {
        btnNo.addEventListener("click", function () {
            if (elNotVerification) {
                elNotVerification.classList.remove("d-none");
                elNotVerification.innerHTML = `
                    <p>Доступ на сайт дозволений тільки особам старше 18 років, які є споживачами нікотиновмісних виробів.</p>
                    <p>18+ Цей веб-сайт містить інформацію про нікотиновмісні продукти</p>
                `;
            }
            if (elPopContent) {
                elPopContent.classList.add("d-none");
            }
        });
    }
}

function initParallaxSection() {
    gsap.registerPlugin(ScrollTrigger);
    let panels = gsap.utils.toArray(".js-parallax-block");
    // we'll create a ScrollTrigger for each panel just to track when each panel's top hits the top of the viewport (we only need this for snapping)
    let tops = panels.map(panel => ScrollTrigger.create({trigger: panel, start: "top top"}));

    panels.forEach((panel, i) => {
        ScrollTrigger.create({
            trigger: panel,
            start: () => panel.offsetHeight < window.innerHeight ? "top top" : "bottom bottom", // if it's shorter than the viewport, we prefer to pin it at the top
            pin: true,
            pinSpacing: false
        });
    });

    // ScrollTrigger.create({
    //     snap: {
    //         snapTo: (progress, self) => {
    //             let panelStarts = tops.map(st => st.start), // an Array of all the starting scroll positions. We do this on each scroll to make sure it's totally responsive. Starting positions may change when the user resizes the viewport
    //                 snapScroll = gsap.utils.snap(panelStarts, self.scroll()); // find the closest one
    //             return gsap.utils.normalize(0, ScrollTrigger.maxScroll(window), snapScroll); // snapping requires a progress value, so convert the scroll position into a normalized progress value between 0 and 1
    //         },
    //         duration: 0.5
    //     }
    // });
}

let quizSwiper;

function initQuizSlider() {
    quizSwiper = new Swiper('.swiper', {
        direction: 'horizontal',
        loop: false,
        mousewheel: false,
        allowTouchMove: false,

        navigation: {
            nextEl: '.btn-next-1, .btn-next-2, .btn-next-3, .btn-next-4, .btn-next-5',
            prevEl: '.btn-prev-1, .btn-prev-2, .btn-prev-3, .btn-prev-4, .btn-prev-5, .btn-prev-6',
        },
    });
}

function initQuiz() {
    const slides = document.querySelectorAll('.quiz__slide');

    slides.forEach((slide, index) => {
        const inputs = slide.querySelectorAll('input[type="radio"]');
        const nextBtn = slide.querySelector('.slider-btn.btn-next');

        if (!nextBtn || inputs.length === 0) return;

        inputs.forEach(input => {
            input.addEventListener('change', () => {
                if (slide.querySelector('input[type="radio"]:checked')) {
                    nextBtn.classList.remove('button-disabled');

                    if (index < slides.length - 1) {
                        setTimeout(() => {
                            quizSwiper.slideNext();
                        }, 300);
                    } else {
                        const answers = collectQuizAnswers();
                        onQuizComplete(answers);
                    }
                }
            });
        });
    });
}

function collectQuizAnswers() {
    const answers = {};
    document.querySelectorAll('.quiz__slide').forEach(slide => {
        const checked = slide.querySelector('input[type="radio"]:checked');
        if (checked) {
            const letter = checked.id.split('_').pop().toUpperCase();
            answers[checked.name] = letter;
        }
    });
    return answers;
}


function onQuizComplete(answers) {
    const values = Object.values(answers);
    const counts = {A: 0, B: 0, C: 0};
    values.forEach(val => {
        if (counts[val] !== undefined) {
            counts[val]++;
        }
    });

    let winner = "A";
    if (counts.B > counts[winner]) winner = "B";
    if (counts.C > counts[winner]) winner = "C";

    switch (winner) {
        case "A":
            setQuizResult('A')
            break;
        case "B":
            setQuizResult('B')
            break;
        case "C":
            setQuizResult('C')
            break;
    }
}

function setQuizResult(answer) {
    const elQuizResult = document.getElementById('quizResult');
    const elQuizPreloader = document.getElementById('quizPreloader');

    if (!elQuizResult) return;
    if (elQuizPreloader) {
        elQuizPreloader.classList.add('active')
    }

    const elQuizResultSubtitle = elQuizResult.querySelector('.quiz__result-subtitle');
    const elQuizResultText = elQuizResult.querySelector('.quiz__result-text');

    if (answer === 'A') {
        // elQuizResult.style.backgroundImage = "url('../img/quiz-a.webp')";
        elQuizResult.classList.add('quiz-a');
        elQuizResultSubtitle.innerHTML = 'Більше відповідей (A):';
        elQuizResultText.innerHTML = 'Вас надихають яскраві події та нові враження. Ключ до вашого натхнення чекає на вершині гори або на березі моря.';
    }
    if (answer === 'B') {
        // elQuizResult.style.backgroundImage = "url('../img/quiz-b.webp')";
        elQuizResult.classList.add('quiz-b');
        elQuizResultSubtitle.innerHTML = 'Більше відповідей (B):';
        elQuizResultText.innerHTML = 'Ви цінуєте справжній стиль та збалансовані враження. Уважні до деталей, цінуєте досконалість та надихаєтесь подіями та шедеврами, що залишають незабутні спогади.';
    }
    if (answer === 'C') {
        // elQuizResult.style.backgroundImage = "url('../img/quiz-c.webp')";
        elQuizResult.classList.add('quiz-c');
        elQuizResultSubtitle.innerHTML = 'Більше відповідей (C):';
        elQuizResultText.innerHTML = 'Вам завжди цікаво у власній компанії і ніколи не нудно наодинці. Справжнє джерело натхнення – всередині вашої душі, чутливої до витонченої естетики.';
    }

    setTimeout(() => {
        elQuizResult.classList.add('active');

        if (typeof window.dataLayer.push == 'function') {
            window.dataLayer.push({
                event: "quiz_completed"
            });
        }

        if (elQuizPreloader) {
            elQuizPreloader.classList.remove('active');
        }
    }, 500);
}

function initBtnNewQuiz() {
    document.getElementById('btnNewQuiz')?.addEventListener('click', () => {
        document.querySelectorAll('.quiz__slide input[type="radio"]').forEach(input => {
            input.checked = false;
        });
        document.querySelectorAll('.quiz__slide .slider-btn.btn-next').forEach(btn => {
            btn.classList.add('button-disabled');
        });
        if (quizSwiper) {
            quizSwiper.slideTo(0);
        }
        const elQuizResult = document.getElementById('quizResult');
        if (elQuizResult) {
            elQuizResult.classList.remove('active');
            [...elQuizResult.classList].filter(cls => cls.startsWith('quiz-')).forEach(cls => elQuizResult.classList.remove(cls));
        }
    });
}

function initScrollButtons(){
    const navbarItems = document.querySelectorAll(".js-btn-scroll-to-section");
    const navbar = document.querySelector(".navbar");

    function scrollNavbarIntoView(btn) {
      if (!navbar) return;

      const btnRect = btn.getBoundingClientRect();
      const navRect = navbar.getBoundingClientRect();

      // console.log('btnRect',btnRect)
      // console.log('navRect',navRect)

      if (btnRect.left < navRect.left) {
        navbar.scrollBy({
          left: btnRect.left - navRect.left - 20,
          behavior: "smooth"
        });
      }

      if (btnRect.right > navRect.right) {
        navbar.scrollBy({
          left: btnRect.right - navRect.right + 20,
          behavior: "smooth"
        });
      }
    }

    navbarItems.forEach((btn, _, allBtns) => {
        btn.addEventListener("click", () => {
            const target = btn.getAttribute("data-target");

            if (target) {
                const targetEl = document.querySelector(target);
                if (targetEl) {
                    const targetY = targetEl.getBoundingClientRect().top + window.scrollY - 10; // offsetY = 10
                    const distance = Math.abs(targetY - window.scrollY);
                    const speed = 4000; // px per second
                    const duration = distance / speed;

                    gsap.to(window, {
                        duration: duration,
                        scrollTo: { y: targetY }
                    });
                }
            }

            allBtns.forEach(el => el.classList.remove("active"));
            btn.classList.add("active");

            scrollNavbarIntoView(btn);
        });
    });

    const sections = document.querySelectorAll("section[id]");
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const id = "#" + entry.target.id;

                navbarItems.forEach(btn => {
                  const isActive = btn.getAttribute("data-target") === id;
                  btn.classList.toggle("active", isActive);

                  if (isActive) {
                    scrollNavbarIntoView(btn);
                  }
                });
            }
        });
    }, { threshold: 0.6 });

    sections.forEach(section => observer.observe(section));

}


function getVideoSrcFromSources(video) {
  const sources = video.querySelectorAll("source");

  for (let source of sources) {
    if (!source.media || window.matchMedia(source.media).matches) {
      return source.src;
    }
  }

  return null;
}

function updateVideoSource(video) {
  const newSrc = getVideoSrcFromSources(video);

  if (newSrc && video.dataset.currentSrc !== newSrc) {
    video.src = newSrc;
    video.dataset.currentSrc = newSrc;

    video.load();
    video.play().catch(() => {
      console.log("Автовідтворення заблоковане, потрібна взаємодія користувача.");
      video.controls = true;
    });
  }
}

function initVideoPlayers() {
  const videos = document.querySelectorAll(".video-player");
  if (!videos.length) return;

  videos.forEach((video, index) => {
    video.loop = true;
    video.controls = false;

    updateVideoSource(video);

    window.addEventListener("resize", () => updateVideoSource(video));

    video.addEventListener("ended", () => {
      video.currentTime = 0;
      video.play();
    });
  });
}


document.addEventListener('DOMContentLoaded', function () {
    popupAgeVerification();
    initParallaxSection();
    initQuizSlider();
    initQuiz();
    initBtnNewQuiz();
    initScrollButtons();
    initVideoPlayers();
});
